import { device } from '../constants/actionTypes';

/**
 * @issue About iPadOS: https://developer.apple.com/forums/thread/119186
 * @note  2020/3/20 iPadOS 13.4 之後若接上外部 pointer 裝置，可支援 CSS hover，因此不能以能否 hover 做判斷, ref: https://blog.user.today/ipados-mouse-event-test/
 * @note  iPadOS 在前端的 UI 呈現需求，目前要等同於 mobile，因此直接覆蓋主要裝置類型的值
 */
export default (state = {}, action) => {
  switch(action.type) {
    case device.CHECK_IPAD_OS:
      return action.payload ? {
        isMobile: action.payload,
        isTablet: action.payload,
        isDesktop: !action.payload,
        // isIpadOs: action.payload,
      } : {
        ...state,
        // isIpadOs: action.payload,
      }
    default:
      return state;
  }
};
